import { useState } from 'react';
import { axiosApi } from '../../api/setupApi';

const useDeleteUser = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const deleteUser = async (userId) => {
    setIsDeleting(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await axiosApi.delete(`/auth/delete_user/${userId}`);
      const data = response.data;
      setSuccessMessage(data.message || 'User deleted successfully');
      return data;
    } catch (err) {
      console.error('Error in useDeleteUser:', err.message);
      setError(err.message);
      throw err; // Re-throw to allow component to handle
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteUser, isDeleting, error, successMessage };
};

export default useDeleteUser;
